import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./it.json";
import en from "./en.json";
// chiavi aggiunte dagli stream frontend (a = dashboard/piano/fornitori/report/admin, b = audit/NC/azioni/evidenze)
import aIt from "./a.it.json";
import aEn from "./a.en.json";
import bIt from "./b.it.json";
import bEn from "./b.en.json";
// chiavi dello stream account-mail (sicurezza account, posta in uscita, origine audit)
import cIt from "./c.it.json";
import cEn from "./c.en.json";
// chiavi dello stream app-rules (regole del rating, informative GDPR, conservazione, integrità)
import dIt from "./d.it.json";
import dEn from "./d.en.json";
// chiavi dello stream notifiche (configurazione di quando e come inviare)
import eIt from "./e.it.json";
import eEn from "./e.en.json";
// chiavi dello stream stabilimenti (AUD-F2.15)
import fIt from "./f.it.json";
import fEn from "./f.en.json";
// chiavi dei valori a mano dell'admin (AUD-F2.20)
import gIt from "./g.it.json";
import gEn from "./g.en.json";
// chiavi del programma compilato nel tool (AUD-F2.14b)
import hIt from "./h.it.json";
import hEn from "./h.en.json";
// chiavi delle richieste di Pier del 02/11 (AUD-F8.4)
import iIt from "./i.it.json";
import iEn from "./i.en.json";

/** Stringhe estratte dal mockup v2 (tabella I18N). Chiavi nuove: aggiungerle in entrambi i file. */
const saved = (() => {
  try {
    return localStorage.getItem("ap.lang");
  } catch {
    return null;
  }
})();

void i18n.use(initReactI18next).init({
  resources: { it: { translation: { ...it, ...aIt, ...bIt, ...cIt, ...dIt, ...eIt, ...fIt, ...gIt, ...hIt, ...iIt } }, en: { translation: { ...en, ...aEn, ...bEn, ...cEn, ...dEn, ...eEn, ...fEn, ...gEn, ...hEn, ...iEn } } },
  lng: saved === "en" ? "en" : "it",
  fallbackLng: "it",
  interpolation: { escapeValue: false },
});

export function setLang(l: "it" | "en") {
  void i18n.changeLanguage(l);
  try {
    localStorage.setItem("ap.lang", l);
  } catch {
    /* storage non disponibile */
  }
}
export default i18n;
